export default __webpack_public_path__ + "static/media/reddit.84ba1edf.png";